import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import urlUtis from '../../utils/url.util';
import { PRODUCT } from '../../constants/product.const';

const ProductSortSelect = () => {
    const [defaultValue, setDefaultValue] = useState(
        PRODUCT.SORT_ORDER_TYPE.NEW
    );

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const sortType = urlParams.get('sort');
        if (sortType) {
            setDefaultValue(+sortType);
        }
    }, [window.location.search]);

    const handleChange = (s) => {
        urlUtis.insertParam('sort', +s.target.value);
    };

    return (
        <form className="order-by">
            <p>Sắp xếp theo :</p>
            <select
                className="orderby"
                name="orderby"
                onChange={handleChange}
                value={defaultValue}
            >
                <option value={PRODUCT.SORT_ORDER_TYPE.HOT}>
                    Sản phẩm bán chạy
                </option>
                <option value={PRODUCT.SORT_ORDER_TYPE.NEW}>
                    Sản phẩm mới
                </option>
                <option value={PRODUCT.SORT_ORDER_TYPE.PRICE_LOW}>
                    Giá từ thấp đến cao
                </option>
                <option value={PRODUCT.SORT_ORDER_TYPE.PRICE_HIGHT}>
                    Giá từ cao đến thấp
                </option>
            </select>
        </form>
    );
};

export default ProductSortSelect;

document
    .querySelectorAll('react-product-sort-select')
    .forEach((domContainer) => {
        const root = createRoot(domContainer);

        root.render(<ProductSortSelect />);
    });
